/** @jsx jsx */
import { Fragment } from 'preact';
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useTheme, CacheProvider } from '../../../providers';
import { createHoverProps } from '../../../toolbox';
const CSS = {
    hierarchy: ({ theme }) => css({
        '& .ss__facet-hierarchy-options__option': {
            display: 'flex',
            padding: '6px 0',
            textDecoration: 'none',
            alignItems: 'center',
            '&:hover': {
                cursor: 'pointer',
                background: theme.colors?.hover,
            },
            '&.ss__facet-hierarchy-options__option--filtered': {
                fontWeight: 'bold',
                color: theme.colors?.primary,
                '&:hover': {
                    cursor: 'default',
                    background: 'unset',
                },
                '& ~ .ss__facet-hierarchy-options__option:not(.ss__facet-hierarchy-options__option--filtered)': {
                    paddingLeft: '16px',
                },
            },
            '&.ss__facet-hierarchy-options__option--return': {
                '&:before': {
                    content: `'\\0000ab'`,
                    padding: '0 2px 0 0',
                    color: theme.colors?.primary,
                },
            },
            '& .ss__facet-hierarchy-options__option__value': {
                marginLeft: '8px',
                '& .ss__facet-hierarchy-options__option__value__count': {
                    fontSize: '0.8em',
                    marginLeft: '6px',
                },
            },
        },
    }),
};
export const FacetHierarchyOptions = observer((properties) => {
    const globalTheme = useTheme();
    const theme = { ...globalTheme, ...properties.theme };
    const props = {
        // default props
        // global theme
        ...globalTheme?.components?.facetHierarchyOptions,
        //props
        ...properties,
        ...properties.theme?.components?.facetHierarchyOptions,
    };
    const { values, hideCount, onClick, disableStyles, previewOnFocus, valueProps, facet, className, style } = props;
    const styling = {};
    if (!disableStyles) {
        styling.css = [CSS.hierarchy({ theme }), style];
    }
    else if (style) {
        styling.css = [style];
    }
    const facetValues = values || facet?.values;
    return facetValues?.length ? (jsx(CacheProvider, null,
        jsx("div", { ...styling, className: classnames('ss__facet-hierarchy-options', className) }, facetValues.map((value) => (jsx("a", { className: classnames('ss__facet-hierarchy-options__option', { 'ss__facet-hierarchy-options__option--filtered': value.filtered }, { 'ss__facet-hierarchy-options__option--return': value.history && !value.filtered }), "aria-label": value.filtered
                ? `remove selected filter ${facet?.label || ''} - ${value.label}`
                : facet?.label
                    ? `filter by ${facet?.label} - ${value.label}`
                    : `filter by ${value.label}`, href: value.url?.link?.href, ...valueProps, onClick: (e) => {
                value.url?.link?.onClick(e);
                onClick && onClick(e);
            }, ...(previewOnFocus ? createHoverProps(() => value?.preview && value.preview()) : {}) },
            jsx("span", { className: "ss__facet-hierarchy-options__option__value" },
                value.label,
                !hideCount && value?.count > 0 && !value.filtered && (jsx("span", { className: "ss__facet-hierarchy-options__option__value__count" },
                    "(",
                    value.count,
                    ")"))))))))) : (jsx(Fragment, null));
});
